import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { useIntl } from 'react-intl';

import { RootState } from '@share/utils';
import { GetWalletAmount, GetWalletNumber, IsCapitalVacationsAccount } from '@share/utils';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWallet } from '@fortawesome/free-solid-svg-icons';

import './style.scss';

interface IProps {
  onClick: () => void;

  className?: string;
}

export function HeaderWalletChip(props: IProps) {
  const { onClick, className } = props;

  const intl = useIntl();

  const loginStore = useSelector((state: RootState) => state.loginStore);

  const { account, user, userWallet, userWalletData } = loginStore;

  const hasClientCash = account?.hasClientCash;
  const isLoggedAshevillePlay = account?.isAshevillePlay && !user?.isAshevillePlayAdmin;
  const isLogged = !!userWallet || isLoggedAshevillePlay;

  if (!hasClientCash || !isLogged) {
    return null;
  }

  const balance = GetWalletNumber(userWalletData?.balance as number, account);

  if (balance === undefined) {
    return null;
  }

  const clientCashName = isEmpty(account?.walletClientCashName)
    ? 'Client Cash'
    : account?.walletClientCashName;

  const isCapital = IsCapitalVacationsAccount(account);

  return (
    <button
      type="button"
      className={`header-wallet-chip ${className ? className : ''}`}
      onClick={onClick}
      aria-label={intl.formatMessage(
        { id: isCapital ? 'wallet.header.chip.aria.points' : 'wallet.header.chip.aria' },
        { clientCash: clientCashName, balance },
      )}
    >
      <FontAwesomeIcon className="header-wallet-chip__icon" icon={faWallet} />
      <span className="header-wallet-chip__balance">{GetWalletAmount(userWalletData?.balance, account, userWalletData, clientCashName)}</span>
    </button>
  );
}
